import { useEffect, useRef } from "react";

const DateRangeSelector = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Cargar el CSS
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://app.lobbypms.com/public/css/widget/lobby-date-rage-selector.min.css?v=qqbradNcbeUpNq95vdR1ILtIb";
    document.head.appendChild(link);

    // Cargar el script JS
    const script = document.createElement("script");
    script.src = "https://app.lobbypms.com/public/js/widget/lobby-date-rage-selector.min.js?v=EPx86P1C1e63qyfAH6m0at6ZA";
    script.async = true;
    script.onload = () => {
      // Asegúrate que la clase esté disponible
      if (window.LobbyDateRangeSelector) {
        new window.LobbyDateRangeSelector({
          apiBaseUrl: 'https://api.lobbypms.com/api/ldrs/',
          token: 'xpaO773nJ6qFsLORDLrbz1nAy9i6z2tfFRFTFM3i7oUm6shJTqkwIr0IFHIG',
          lang: 'es',
          container: containerRef.current, // Asume que puedes montar en un div específico
        });
      }
    };
    document.body.appendChild(script);

    // Limpieza al desmontar el componente
    return () => {
      document.head.removeChild(link);
      document.body.removeChild(script);
    };
  }, []);

  return <div ref={containerRef}></div>;
};

export default DateRangeSelector;